module.exports = "pegasus/assets/theme6/medium/7.jpg";